export class TranslateTableModel {
    public id: any;
    public field_name: string;
    public field_value: string;
    public description: string;
    public field_short_name: string;
    public effective_date: any;
    public effective_status: string;
    public fieldValues: string[];
    public comment: string;
    public created_dt: Date;
    public created_by: string;
    public updated_dt: Date;
    public updated_by: string;
    public edate: string;
    
    constructor() {
        this.id = "";
        this.field_name = "";
        this.field_value = "";
        this.description = "";
        this.field_short_name = "";
        this.effective_date = "";
        this.effective_status = "";
        this.fieldValues = [];
        this.comment = "";
        this.created_dt = null;
        this.created_by = "";
        this.updated_dt = null;
        this.updated_by = "";
        this.edate = "";
    }


}
